<button type="button" class="button-modal" (click)="config = true">
    <fa-icon [icon]="faFilter"></fa-icon>
</button>

<div class="container-modal" *ngIf="config">
    <div class="modal-dock">
        <div class="modal-title-container">
            <h3 class="modal-title">Escolha uma doca</h3>
        </div>
        <select class="form-control" type="number" [(ngModel)]="selectedDock" (ngModelChange)="changeDockPage()">
            <option *ngFor="let selected of recDocks" [ngValue]="selected.id">
                <p>{{ selected.description }}</p>
            </option>
        </select>
        <button class="modal-icon" (click)="config = false">X</button>
    </div>
</div>

<div class="trip-details">
    <router-outlet></router-outlet>
</div>